<script lang="ts" setup>
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import CustomerForm from '@/components/features/customers/CustomerForm.vue'

import { useRouter } from 'vue-router'
import { addCustomer } from '@/api/customers'
import { useCustomerForm } from '@/composables/useCustomerForm'
import type { ErrorResponse } from '@/types/error-types'

const {
  values,
  loading,
  handleSubmit,
  addressFields,
  newAddress,
  removeAddress,
  setErrors,
  showToast,
  formType
} = useCustomerForm('add')

const router = useRouter()

const onSubmit = handleSubmit(async () => {
  loading.value = true
  const addresses =
    values?.addresses?.map((address: any) => ({
      ...address,
      country: address?.country,
      location: address?.location?.id,
      addressType: address?.addressType?.id
    })) || []

  await addCustomer({
    ...values,
    addresses
  })
    .then(() => {
      loading.value = false
      showToast('success', 'Customer Added!', 'You have successfully added a new customer.')
      router.push('/customers')
    })
      .catch((error: { response?: { data: ErrorResponse } }) => {
        loading.value = false
        const errorMessages = error.response?.data?.errors?.map((err) => err.description).join('\n') || 'Unable to add new customer.'
        showToast('error', 'An error occurred!', errorMessages)
      })
},
  (errors: Record<string, string>) => {
  loading.value = false

  const errorObjects = Object.entries(errors.errors).map(([field, message]) => ({
    code: field,
    description: message,
  }))

  if(errorObjects.length > 0) {
    const firstError = errorObjects[0]
    const errorMessage = ` ${firstError.description}`
    showToast('error', 'Validation Error', errorMessage)
    return
  }
})
</script>

<template>
  <PageHeader
    title="Add a customer"
    buttonText="Save Customer"
    buttonIcon="material-symbols:save"
    :buttonClick="onSubmit"
    :loading="loading"
  />

  <CustomerForm
    :type="formType"
    :values="values"
    :onSubmit="onSubmit"
    :addressFields="addressFields"
    :newAddress="newAddress"
    :removeAddress="removeAddress"
    :setErrors="setErrors"
    :show-toast="showToast"
  />
</template>
<style></style>
